import { dramaCategories, dramas } from "@/mocks/dramas";

export interface CategoryFilters {
  type: string;
  status: string;
  year: string;
  sort: string;
}

interface FilterBarProps {
  filters: CategoryFilters;
  onChange: (patch: Partial<CategoryFilters>) => void;
  onReset: () => void;
}

const STATUS_OPTIONS = ["全部", "更新中", "已完结"];
const SORT_OPTIONS = [
  { key: "update", label: "最近更新" },
  { key: "rating", label: "人气评分" },
  { key: "year", label: "年份最新" },
];

const years = Array.from(new Set(dramas.map((drama) => String(drama.year)))).sort((a, b) => Number(b) - Number(a));

function pillClass(active: boolean) {
  return `cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
    active
      ? "bg-primary-500 text-background-50"
      : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
  }`;
}

export default function FilterBar({ filters, onChange, onReset }: FilterBarProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 md:flex-row md:gap-5">
        <span className="flex w-16 shrink-0 items-center text-xs font-medium text-foreground-500">剧情类型</span>
        <div className="flex flex-wrap gap-2">
          <button type="button" className={pillClass(filters.type === "")} onClick={() => onChange({ type: "" })}>
            全部
          </button>
          {dramaCategories.map((category) => (
            <button
              key={category.key}
              type="button"
              className={pillClass(filters.type === category.key)}
              onClick={() => onChange({ type: category.key })}
            >
              {category.key}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 md:flex-row md:gap-5">
        <span className="flex w-16 shrink-0 items-center text-xs font-medium text-foreground-500">更新状态</span>
        <div className="flex flex-wrap gap-2">
          {STATUS_OPTIONS.map((status) => (
            <button
              key={status}
              type="button"
              className={pillClass(filters.status === (status === "全部" ? "" : status))}
              onClick={() => onChange({ status: status === "全部" ? "" : status })}
            >
              {status}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 md:flex-row md:gap-5">
        <span className="flex w-16 shrink-0 items-center text-xs font-medium text-foreground-500">首播年份</span>
        <div className="flex flex-wrap gap-2">
          <button type="button" className={pillClass(filters.year === "")} onClick={() => onChange({ year: "" })}>
            全部
          </button>
          {years.map((year) => (
            <button
              key={year}
              type="button"
              className={pillClass(filters.year === year)}
              onClick={() => onChange({ year })}
            >
              {year}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 border-t border-background-200 pt-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-medium text-foreground-500">排序</span>
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.key}
              type="button"
              className={pillClass(filters.sort === option.key)}
              onClick={() => onChange({ sort: option.key })}
            >
              {option.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onReset}
          className="flex cursor-pointer items-center gap-1 self-start whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600 md:self-auto"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}